module.exports = __webpack_public_path__ + "img/zjs1.dc845be4.png";